import { Request } from '@/classes/Request'

/**
 * DTA-659: submission ids are ObjectId strings, not numbers. This endpoint's
 * column (ww_assoc_family_user_contract_revision.fldFormSubmissionId) is clean
 * today because both callers pass a real id and the server skips empty values —
 * the type is corrected so nobody reaches for `?? 0` here the way the assigned-fee
 * path did. Behaviour is deliberately unchanged.
 */
export const setTuitionFormSubmissionId = async (
  formSubmissionId: string,
  studentAccountId: number,
  contractRevisionId: number
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/set_contract_revision_signing_form`, {
        form_submission_id: formSubmissionId,
        student_account_id: studentAccountId,
        contract_revision_id: contractRevisionId
      })
      .then(() => {
        resolve()
      })
      .catch(() => {
        reject('Failed to set form submission ID')
      })
  })
}
